import { CustomerModel } from "interfaces/customer";
import { ApiContext } from "../ApiContext";

export class ApiClents extends ApiContext {
    public async getClients() {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`
            }
        }

        return this.client.httpAuth
            .get<CustomerModel[]>(`/clients`, config)
            .then((res) => res.data);
    }
    public async getClientsByGroup(group_id: string) {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`
            }
        }

        return this.client.httpAuth
            .get<CustomerModel[]>(`/gpempresa-by-group/${group_id}`, config)
            .then((res) => res.data);
    }
}
